module.exports = __webpack_public_path__ + "img/category-Comedy.ed20ec94.svg";